import React from 'react';
import ReactDOM from 'react-dom';
import {ApolloProvider} from 'react-apollo';
import {ApolloClient} from 'apollo-client';
import {HttpLink} from 'apollo-link-http';
import {ApolloLink, concat, split} from 'apollo-link';
import {WebSocketLink} from 'apollo-link-ws';
import {onError} from 'apollo-link-error';
import {InMemoryCache} from 'apollo-cache-inmemory';
import {getMainDefinition, toIdValue} from 'apollo-utilities';
import {createStore} from 'redux';
import {persistStore} from 'redux-persist';
import {Provider} from 'react-redux';
import {Config} from 'app.config';
import App from './App';
import callemanApp from 'reducers';
import 'scss/main.scss';
import {PersistGate} from "redux-persist/es/integration/react";
import 'helpers/validators';
import Raven from 'raven-js';
import {ErrorHandler, logGraphQLError, logNetworkError} from "helpers/errors";
import {IntlProvider, addLocaleData} from "react-intl";
import moment from 'moment';
import 'moment/locale/cs';
import messagesCs from 'translations/cs.json';
import cs from 'react-intl/locale-data/cs';

moment.locale('cs');

addLocaleData(cs);

/****** Raven (Sentry) ******/
const options = {
    release: process.env.REACT_APP_VERSION,

};
Raven.config(Config.sentry_dsn, options).install();
Raven.setTagsContext({module: 'frontend'});

/****** Redux Store ******/
const store = createStore(callemanApp);
const persistor = persistStore(store);

/****** Apollo ******/
const authMiddleware = new ApolloLink((operation, forward) => {
    const state = store.getState();
    const token = state.user ? state.user.accessToken : null;

    if (token) {
        operation.setContext({
            headers: {
                Authorization: 'Bearer ' + token,
            }
        });
    }

    return forward(operation);
});

const httpLink = new HttpLink({uri: Config.graphql_host});

const wsLink = new WebSocketLink({
    uri: Config.websocket_host,
    options: {
        reconnect: true,
        lazy: true,
        connectionParams: () => {
            const state = store.getState();
            const token = state.user ? state.user.accessToken : null;
            return {Authorization: 'Bearer ' + token};
        }
    }
});

const errorLink = onError(({graphQLErrors, networkError}) => {
    if (graphQLErrors) {
        graphQLErrors.forEach((error) => {
            logGraphQLError(error);
        });
    }

    if (networkError) {
        logNetworkError(networkError);
    }
});

const link = concat(
    errorLink,
    split(
        ({query}) => {
            const {kind, operation} = getMainDefinition(query);
            return kind === 'OperationDefinition' && operation === 'subscription';
        },
        wsLink,
        concat(authMiddleware, httpLink)
    )
);

const cache = new InMemoryCache({
    cacheResolvers: {
        Query: {
            ad: (_, args) => toIdValue(cache.config.dataIdFromObject({__typename: "Ad", id: args.adId})),
            customerProfile: (_, args) => toIdValue(cache.config.dataIdFromObject({
                __typename: "CustomerProfile",
                id: args.customerProfileId
            })),
        }
    }
});

const client = new ApolloClient({
    link,
    cache
});

client.restartWebsocketConnection = () => {
    if (wsLink) {
        wsLink.subscriptionClient.close(true);
    }
};

ReactDOM.render(
    <Provider store={store}>
        <PersistGate persistor={persistor}>
            <IntlProvider locale="cs" messages={messagesCs}>
                <ErrorHandler>
                    <ApolloProvider client={client}>
                        <App/>
                    </ApolloProvider>
                </ErrorHandler>
            </IntlProvider>
        </PersistGate>
    </Provider>
    , document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js